module.exports = __webpack_public_path__ + "img/sv72on.3834d6e0.svg";